import { render, staticRenderFns } from "./ComplementaryPayrollsTable.vue?vue&type=template&id=8db8303c"
import script from "./ComplementaryPayrollsTable.vue?vue&type=script&lang=js"
export * from "./ComplementaryPayrollsTable.vue?vue&type=script&lang=js"
import style0 from "./ComplementaryPayrollsTable.vue?vue&type=style&index=0&id=8db8303c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports